import { render, staticRenderFns } from "./custom-field-order-widget.vue?vue&type=template&id=551b4775&"
import script from "./custom-field-order-widget.vue?vue&type=script&lang=js&"
export * from "./custom-field-order-widget.vue?vue&type=script&lang=js&"
import style0 from "./custom-field-order-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports